import { render } from "./CardSocialTraffic.vue?vue&type=template&id=9e372d2c"
const script = {}

import exportComponent from "/Users/yaakovbeckerman/projects/vue-notus/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__